import React from 'react';
import { FiSend } from 'react-icons/fi';

const RecordingPopup = ({ onCancel, onSend }) => {
    return (
        <div className="fixed bottom-28 left-1/2 transform -translate-x-1/2 bg-black/90 text-white px-6 py-4 rounded-2xl flex items-center space-x-4 z-50 shadow-lg">
            <div className="animate-pulse w-4 h-4 bg-red-500 rounded-full"></div>
            <span>Recording...</span>

            <button
                onClick={onCancel}
                className="ml-2 p-2 rounded-full hover:bg-white/10"
                title="Cancel recording"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                >
                    <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                        clipRule="evenodd"
                    />
                </svg>
            </button>

            <button
                onClick={onSend}
                className="ml-2 text-white p-2 rounded-full hover:bg-white/10"
                title="Send recording"
            >
                <FiSend className="w-5 h-5" />
            </button>
        </div>
    );
};

export default RecordingPopup;